const t = "5.15.0", e = {
  /**
   * Extra small breakpoint, for mobile devices
   */
  xs: {
    mediaQuery: "(min-width: 0) and (max-width: 575px)",
    screenWidthRange: "0 - 575px",
    minScreenWidth: "0px",
    maxScreenWidth: "575px",
    containerMaxWidth: "100%",
    viewportWidth: 360
  },
  /**
   * Small breakpoint, for larger mobile devices and tablets
   */
  sm: {
    mediaQuery: "(min-width: 576px) and (max-width: 767px)",
    screenWidthRange: "576px - 767px",
    minScreenWidth: "576px",
    maxScreenWidth: "767px",
    containerMaxWidth: "520px",
    viewportWidth: 767
  },
  /**
   * Medium breakpoint for tablets and small desktops
   */
  md: {
    mediaQuery: "(min-width: 768px) and (max-width: 1023px)",
    screenWidthRange: "768px - 1023px",
    minScreenWidth: "768px",
    maxScreenWidth: "1023px",
    containerMaxWidth: "740px",
    viewportWidth: 962
  },
  /**
   * Large breakpoint for desktops
   */
  lg: {
    mediaQuery: "(min-width: 1024px) and (max-width: 1199px)",
    screenWidthRange: "1024px - 1199px",
    minScreenWidth: "1024px",
    maxScreenWidth: "1199px",
    containerMaxWidth: "960px",
    viewportWidth: 1180
  },
  /**
   * Extra large breakpoint for large desktops
   */
  xl: {
    mediaQuery: "(min-width: 1200px) and (max-width: 1499px)",
    screenWidthRange: "1200px - 1499px",
    minScreenWidth: "1200px",
    maxScreenWidth: "1499px",
    containerMaxWidth: "1160px",
    viewportWidth: 1366
  },
  /**
   * Extra extra large breakpoint for extra large desktops (32inch)
   */
  xxl: {
    mediaQuery: "(min-width: 1500px)",
    screenWidthRange: "1500px and above",
    minScreenWidth: "1500px",
    containerMaxWidth: "1160px",
    viewportWidth: 1920
  }
}, n = Object.keys(
  e
), i = `v${t.replace(/\./g, "")}`, d = ["inline", "overlay"], a = [
  "auto",
  "bottom-start",
  "bottom",
  "bottom-end",
  "top-start",
  "top",
  "top-end",
  "left-start",
  "left",
  "left-end",
  "right-start",
  "right",
  "right-end"
], r = 'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])', o = [
  "2",
  "4",
  "6",
  "8",
  "10",
  "12",
  "16",
  "25perc",
  "50perc",
  "75perc",
  "100perc"
], c = 12, x = ["none", "xs", "sm", "md", "lg", "xl"], p = ["h2", "h3", "h4", "h5", "h6"], h = [
  "around",
  "between",
  "center",
  "evenly",
  "left",
  "right"
], s = ["log", "warn", "error"], m = ["none", "sm", "md", "lg"], S = [
  "danger",
  "info",
  "success",
  "warning"
], E = [
  "inherit",
  "left",
  "center",
  "right",
  "justify"
], W = [
  "danger",
  "info",
  "muted",
  "primary",
  "success",
  "warning",
  "positive",
  "negative"
], l = [
  "blockquote",
  "body",
  "bold",
  "code",
  "display",
  "display1",
  "display2",
  "display3",
  "display4",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "italic",
  "lead",
  "small",
  "cite",
  "caption"
], T = ["top", "middle", "bottom", "stretch"], I = {
  /**
   * The default z-index used for most elements. Can be combined with raised and floating elevations.
   */
  DEFAULT: 0,
  /**
   * Used for IressNavbar. Can be combined with overflow elevation.
   */
  NAVBAR: 100,
  /**
   * Used for IressPopover. Can be combined with floating elevation.
   */
  POPOVER: 200,
  /**
   * Used for IressSlideout. Can be combined with floating elevation.
   */
  SLIDEOUT: 300,
  /**
   * Used for IressModal. Can be combined with floating elevation.
   */
  MODAL: 400,
  /**
   * Used for IressToast. Can be combined with floating elevation.
   */
  TOAST: 500,
  /**
   * Used for IressTooltip. Can be combined with floating elevation.
   */
  TOOLTIP: 600
};
export {
  n as BREAKPOINTS,
  e as BREAKPOINT_DETAILS,
  i as CSS_IDS_VERSION,
  d as DISPLAY_MODES,
  a as FLOATING_UI_ALIGNS,
  r as FOCUSABLE_QUERY_SELECTOR,
  o as FORM_ELEMENT_WIDTHS,
  c as GRID_SIZE,
  x as GUTTER_SIZES,
  p as HEADING_LEVELS,
  h as HORIZONTAL_ALIGNS,
  s as LOGGER_LEVELS,
  m as PADDING_SIZES,
  S as SYSTEM_VALIDATION_STATUSES,
  E as TEXT_ALIGNS,
  W as TEXT_MODES,
  l as TEXT_VARIANTS,
  T as VERTICAL_ALIGNS,
  I as Z_INDEX
};
